import { type EditCellEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function requestCellEditReducer(
  state: SelectionState,
  event: EditCellEvent
): ReducerResponse {
  if (!state.focusedCell) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: state,
    delta: {
      kind: 'cellEditRequested',
      position: state.focusedCell,
      source: event.source,
    },
  };
}
